<template>
  <v-navigation-drawer 
    id="appDrawer"
    class="dd-dark dd-dark--text"    
    fixed
    app
    v-model="drawer"
    width="260"
    hide-overlay 
    stateless> 
    <v-toolbar color="secondary" dark  d-flex v-if="isHapert" >
      <img src="../../assets/images/Logo_hapert_transparent.png" height="36" alt="Asset Manager">
      <v-toolbar-title class="ml-0 pl-3">        
        <v-flex>
          <span class="hidden-sm-and-down">Hapert</span>
        </v-flex>                
      </v-toolbar-title>            
    </v-toolbar> 
    <v-toolbar color="secondary" dark  d-flex v-else >
      <img src="../../assets/images/DeepDigital_white.png" height="36" alt="Asset Manager">
      <v-toolbar-title class="ml-0 pl-3">        
        <v-flex>
          <span class="hidden-sm-and-down">Asset Manager</span>
        </v-flex>                
      </v-toolbar-title>            
    </v-toolbar>            
    <vue-perfect-scrollbar class="drawer-menu--scroll" :settings="scrollSettings">
      <v-list dense expand class="dd-dark">
        <template v-for="(item, i) in menus">
            <!--group with subitems-->
            <v-list-group v-if="item.items && hasAccess(item)" :key="item.name" :group="item.group"  no-action="no-action">
              <v-list-tile slot="activator" ripple="ripple">
                <v-list-tile-action v-if="item.icon" style="justify-content:center; margin-right:6px">
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-tile-action>                
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <template v-for="(subItem, i) in item.items">
                <!--sub group-->
                <v-list-group v-if="subItem.items && hasAccess(subItem)" :key="subItem.name" :group="subItem.group" sub-group="sub-group" >
                  <v-list-tile slot="activator" ripple="ripple">
                    <v-list-tile-content>
                      <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile v-for="(grand, i) in subItem.children" :key="i" :to="genChildTarget(item, grand)" :href="grand.href" ripple="ripple" >
                    <v-list-tile-content>
                      <v-list-tile-title>{{ grand.title }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list-group>
                <!--child item-->
                <v-list-tile v-else-if='hasAccess(subItem)' :key="i" :to="genChildTarget(item, subItem)" :href="subItem.href" :disabled="subItem.disabled" :target="subItem.target" ripple="ripple">
                  <v-list-tile-content>
                    <v-list-tile-title><span>{{ subItem.title }}</span></v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action v-if="subItem.action">
                    <v-icon :class="[subItem.actionClass || 'success--text']">{{ subItem.action }}</v-icon>
                  </v-list-tile-action>
                </v-list-tile>
              </template>
            </v-list-group>
            <v-subheader v-else-if="item.header && hasAccess(item)" :key="i" >{{ item.header }}</v-subheader>
            <v-divider v-else-if="item.divider" :key="i" ></v-divider>
            <!--top-level link-->
            <v-list-tile v-else-if='hasAccess(item)' :to="!item.href ? { name: item.name } : null" :href="item.href" ripple="ripple" :disabled="item.disabled" :target="item.target" rel="noopener" :key="item.name" >
              <v-list-tile-action v-if="item.icon" style="justify-content:center; margin-right:6px">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action v-if="item.subAction ">
                <v-icon class="success--text">{{ item.subAction }}</v-icon>
              </v-list-tile-action>
            </v-list-tile>
        </template>
      </v-list>
    </vue-perfect-scrollbar>
  </v-navigation-drawer>
</template>
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import menu from  '../../api/tmp_menu';
import { mapGetters } from 'vuex'
import * as types from '../../store/types'

export default {
  name: 'app-drawer',
  components: {
    VuePerfectScrollbar,
  },
  props: {
    expanded: {
      type: Boolean,
      default: true
    },
  },
  data: () => ({
    mini: true,
    drawer: true,
    menus: menu,
    scrollSettings: {
      maxScrollbarLength: 160
    }
  }),
  computed: {
    ...mapGetters({
      mainMenuShown: types.MAIN_MENU_SHOWN,
      topbarDense: types.TOPBAR_DENSE,
      currentUser: types.CURRENT_USER
    }),    
    topbarClass(){
      if(this.topbarDense){
        return ''
      }
      return 'dd-topbar'      
    },
    computeGroupActive () {
      return true;
    }, 
    isHapert(){
        if(this.currentUser && this.currentUser.tenant && this.currentUser.tenant.internalName == 'hapert')
          return true;
        
        return false;
    }   
  },
  created () {
    this.$on('APP_DRAWER_TOGGLED', () => {
      this.drawer = (!this.drawer);
    })
  },
  watch:{
    mainMenuShown(nv){
      this.drawer = nv.show;
    }
  },
  
  methods: {
    hasAccess(item){
      if(item.visibleFor)
      {      
        let found = false
        item.visibleFor.forEach( (role) => {
            if(this.$currentUserHasRole(role)){
              found = true              
            }
        })
        return found
      }
      else if(!item.permission)
        return true
      else
        return this.$currentUserHasPermission(item.permission)

    /*
      if(!item.ddOnly){
        return true
      }
      else{
        if(this.currentUser.tenant.internalName == 'dev'){
          return true
        }
      }
      return false
      */
    },
    genChildTarget (item, subItem) {
      if (subItem.href) 
        return;
      if (subItem.component) {
        return {
          name: subItem.component,
        };
      }
      if(subItem.group)
        return { name: `${item.group}/${(subItem.name)}` };
      
      return { name: subItem.name };
    },
  }
}
</script>

<style lang="stylus">
// @import '../../node_modules/vuetify/src/stylus/settings/_elevations.styl'
// var(--v-primary-base)

#appDrawer  
  overflow: hidden
  .drawer-menu--scroll
    height: calc(100vh - 48px)
    overflow: auto

.dd-topbar{
    height: 160px;    
}


.dd-drawer{
  
}
</style>
